import {
  createStore
} from 'vuex'
export default createStore({
  state: {
    //0第一次进来 1观念检测成功 2支付成功 3手机号绑定成功 4个人信息填写完毕 5密码设置成功 6用户名和头像设置成功 7注册考核成功 8注册审核中 9注册成功 
    //10登录成功
    loginStatus: 0,
    loginInfo: JSON.parse(localStorage.getItem("loginInfo") || '{}'),
    dataList: [],
    nokey: true, // 监听键盘是否弹起，用于隐藏某些浮动元素
    hasMsg: 0,
    key: 0,
    lawKey: 0,
    lawKeys: [],
    forumKey: 0,
    showRight: false,
    hitBottom: true,
    cultureHead: true, // 文化页头部显示状态
    cultureActive: sessionStorage.getItem('culture_active') || 1 // 文化页以及导航选中状态
  },
  getters: {
    userData(state) {
      return state.loginInfo
    }
  },
  mutations: {
    // setDataList(payload,state){
    //   state.dataList = payload
    // }
    // 切换头部导航
    tabCultureActive(state, payload) {
      sessionStorage.setItem('culture_active', payload)
      state.cultureActive = payload
    },
    // 切换头部导航显示状态
    tabCultureHead(state, payload) {
      state.cultureHead = payload
    },
    setMsg(state, payload) {
      state.hasMsg = payload
    },
    setShowRight(state, payload) {
      state.showRight = payload
    },
    setLawKes(state, payload) {
      state.lawKeys.push(payload)
    },
    delLawKeys(state, payload) {
      state.lawKeys.splice(payload, 1)
    },
    delAllLawKeys(state) {
      state.lawKeys = []
    }
  },
  actions: {
    // asyncDataList(store, params){
    //   store.commit('setDataList', params) 
    // }
    asyncSetMsg(context, val) {
      context.commit('setMsg', val)
    }
  },
  modules: {}
})